import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface HeaderProps {
  onClick: () => void;
  title: string;
}

export const Header = ({ title, onClick }: HeaderProps) => (
  <div className="flex h-16 justify-between border-b px-6 py-5">
    <Typography.TitleSm weight="semibold">{title}</Typography.TitleSm>
    <button
      type="submit"
      onClick={onClick}
      aria-label={t("live_streams.room.close_sidebar_button_aria_label")}
    >
      <Icon type="20-close-md" />
    </button>
  </div>
);
